import print from "./print";

export default {
  print,
};
